<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text mb-4">Requests Approval</h2>
      <RequestsApproval/>
  </div>
</template>

<script>
import RequestsApproval from '@/components/Utils/RequestsApproval.vue'
  export default {
    components: {
      RequestsApproval
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>